import request from '@/utils/request'

// 保存为方案
export function addConfiguration(data) {
  return request({
    url: '/configuration/add',
    method: 'post',
    data
  })
}

// 分页查询方案
export function findPageConfiguration(data) {
  return request({
    url: '/configuration/findPage',
    method: 'post',
    data
  })
}

// 上传文件
export function uploadFile(data,type) {
  return request({
    url: '/file/upload/'+`${type}`,
    method: 'post',
    data
  })
}

// 删除配置项
export function deleteConfiguration(configurationId) {
  return request({
    url: '/configuration/delete/'+`${configurationId}`,
    method: 'get'
  })
}

// 查看配置码
export function findConfigurationById(configurationId) {
  return request({
    url: '/configuration/findById/'+`${configurationId}`,
    method: 'get'
  })
}

// 修改配置码
export function updateConfiguration(data) {
  return request({
    url: '/configuration/update',
    method: 'post',
    data
  })
}
